/**
 * Banner UI component
 * @param  data 
 * @returns data.data.banner.title : String
 *          data.data.banner.image : String
 */
import React from "react"
import _ from "lodash"
 function Banner(data) {
    if(!_.isNil(data.data) && (!_.isNil(data.data.bannerAreaTitle))){
        console.log(data);
        return(
            <>
            <div className="page-banner page-banner--image">
               <div className="page-header banner-title--ontop">
                   <div className="container">
                       <h1>{data.data.bannerAreaTitle}</h1>
                       {data.data.bannerAreaText}
                   </div>
               </div>
                <img className="image" src={data.data.bannerAreaImage.localFile.localURL} alt={data.data.bannerAreaImage.altText}/>
            </div>
             <style dangerouslySetInnerHTML={{__html: `
                .page-content {
                    margin-top:240px;
                }
                .page-banner.page-banner--image {
                    background-color:${data.data.bannerAreaBackgroundcolour}
                }
                .page-container {
                    position: relative;
                    z-index: 100;
                }
                .breadcrumbs *{
                    color: #fff !important
                }
                .breadcrumbs li + li:before,
                .breadcrumbs > span + li:before {
                    background:url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='%23FFFFFF' fill-rule='nonzero' d='M8.371 7l-4.527 4.244a.955.955 0 0 0 .002 1.413c.42.393 1.09.391 1.506.002l5.284-4.954a.962.962 0 0 0 .311-.704.96.96 0 0 0-.311-.706L5.352 1.34a1.116 1.116 0 0 0-1.506.002.953.953 0 0 0-.002 1.413L8.37 7z'/%3E%3C/g%3E%3C/svg%3E");
                }
            `}} />
            </>
        )
    } else {
        return null;
    }

 }
 export default Banner